import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnlinestoresComponent } from './onlinestores.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OnlinestoresRoutingModule } from './onlinestores-routing.module';
@NgModule({
  declarations: [OnlinestoresComponent],
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    OnlinestoresRoutingModule
  ]
})
export class OnlinestoresModule { }
